const APIBaseEndpoints = {
  AuthController: '/auth',
  DataController: '',
}

const APIEndpoints = {

  // endpoints login
  authLogin: APIBaseEndpoints.AuthController + '/login',
  authLoginExterno: APIBaseEndpoints.AuthController + '/login-externo',
  authLoginSso: APIBaseEndpoints.AuthController + '/sso',
  authSsoConfig: APIBaseEndpoints.AuthController + '/sso-config',
  authValidate: APIBaseEndpoints.AuthController + '/validate-login',
  authLogout: APIBaseEndpoints.AuthController + '/logout',
  authRefreshToken: APIBaseEndpoints.AuthController + '/refresh',
  authForgotPassword: APIBaseEndpoints.AuthController + '/forgot-password',
  authChangePassword: APIBaseEndpoints.AuthController + '/change-password',
  authRequestChangePassword: APIBaseEndpoints.AuthController + '/request-change-password',
  authIdiomaSelecionado: APIBaseEndpoints.AuthController + '/idioma-selecionado',
  logUsuario: APIBaseEndpoints.AuthController + '/log-usuario',

  idioma: APIBaseEndpoints.DataController + '/idioma',

  log: APIBaseEndpoints.DataController +'/log',
  logMensagem: APIBaseEndpoints.DataController +'/log-mensagem',

  // endpoints of LMS models
  perfilUsuario: APIBaseEndpoints.DataController +'/perfil-usuario',
  perfilPermissoes: APIBaseEndpoints.DataController +'/perfil-permissoes',
  perfil: APIBaseEndpoints.DataController +'/perfil',
  permissoes: APIBaseEndpoints.DataController +'/permissoes',
  usuario: APIBaseEndpoints.DataController +'/usuario',

  disciplina: APIBaseEndpoints.DataController +'/disciplina',
  processoDisciplina: APIBaseEndpoints.DataController +'/processo-disciplina',
  periodoLetivo: APIBaseEndpoints.DataController +'/periodo-letivo',
  curso: APIBaseEndpoints.DataController +'/curso',
  competenciasCurso: APIBaseEndpoints.DataController +'/competencias-curso',
  franqueado: APIBaseEndpoints.DataController +'/franqueado',
  franqueadoUnidade: APIBaseEndpoints.DataController +'/franqueado-unidade',
  franqueadoUnidadeUsuario: APIBaseEndpoints.DataController +'/franqueado-unidade-usuario',
  modulo: APIBaseEndpoints.DataController +'/modulo',
  tipoModulo: APIBaseEndpoints.DataController +'/tipo-modulo',
  aula: APIBaseEndpoints.DataController +'/aula',
  mensagem: APIBaseEndpoints.DataController +'/mensagem',
  contato: APIBaseEndpoints.DataController +'/contato',
  galeria: APIBaseEndpoints.DataController +'/galeria',
  turma: APIBaseEndpoints.DataController +'/turma',
  turmaAluno: APIBaseEndpoints.DataController +'/turma-aluno',
  turmaDisciplina: APIBaseEndpoints.DataController +'/turma-disciplina',
  instrutorDisciplina: APIBaseEndpoints.DataController +'/instrutor-disciplina',
  entregasAtividades: APIBaseEndpoints.DataController +'/entregas-atividades',
  bancoPergunta: APIBaseEndpoints.DataController +'/banco-pergunta',

  salaDeAula: APIBaseEndpoints.DataController +'/sala-de-aula',
  acompanhamento: APIBaseEndpoints.DataController +'/acompanhamento',
  notas:  APIBaseEndpoints.DataController +'/notas',
  alunoNotas:  APIBaseEndpoints.DataController +'/aluno-notas',
  relatorios: APIBaseEndpoints.DataController +'/relatorios',
  relatoriosConfronto: APIBaseEndpoints.DataController +'/relatorio-confronto',

  atividade: APIBaseEndpoints.DataController +'/atividade',
  bancoPerguntasAtividade: APIBaseEndpoints.DataController +'/banco-perguntas-atividade',
  tipoAtividade: APIBaseEndpoints.DataController +'/tipo-atividade',
  pergunta: APIBaseEndpoints.DataController +'/pergunta',
  tipoPergunta: APIBaseEndpoints.DataController +'/tipo-pergunta',
  alternativa: APIBaseEndpoints.DataController +'/alternativa',

  // endpoints do LMS que consultam no ERP
  erp: APIBaseEndpoints.DataController +'/uca-erp',
  erpPortalAlunoPerfil: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/perfil',
  erpPortalAlunoDocumento: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/documento',
  erpPortalAlunoHistoricoEscolar: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/historico-escolar',
  erpPortalAlunoMatricula: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/matricula',
  erpPortalAlunoBoletim: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/boletim',
  erpPortalAlunoAtividadesComplementares: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/atividades-complementares',
  erpPortalAlunoCursos: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/cursos',
  erpPortalAlunoSolicitacao: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/solicitacao',
  erpPortalAlunoCartoes: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/cartoes',
  erpPortalAlunoRenegociacao: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/renegociacao',
  erpPortalAlunoFinanceiro: APIBaseEndpoints.DataController +'/uca-erp/portal-aluno/financeiro',

}

export default APIEndpoints;
